/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { RootState } from '../reducers';

export const getMainScorecard = (state: RootState) => state.scorecard.main;
